import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OrdersState {
  pendingOrdersCount: number;
}

const initialState: OrdersState = {
  pendingOrdersCount: 0,
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setPendingOrdersCount: (state, action: PayloadAction<number>) => {
      state.pendingOrdersCount = action.payload;
    },
  },
});

export const { setPendingOrdersCount } = ordersSlice.actions;
export default ordersSlice.reducer;
